import { normalizePhone } from 'cpool-schemas';

export type OutboundStartChatPayload = {
    customerIdentity: string;
    divisionId: string;
    loanRequestId: string;
    phoneNumberId: string;
};

export const resolveOutboundStartChatPayload = ({
    applicantPhone,
    divisionId,
    loanRequestId,
    phoneNumberId,
}: {
    applicantPhone: string | null | undefined;
    divisionId: string | null | undefined;
    loanRequestId: string;
    phoneNumberId: string | null | undefined;
}): OutboundStartChatPayload | null => {
    if (!applicantPhone || !divisionId || !phoneNumberId) return null;
    const customerIdentity = normalizePhone(applicantPhone);
    if (!customerIdentity) return null;
    return { customerIdentity, divisionId, loanRequestId, phoneNumberId };
};
